import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { DetailedOptionGroup } from './types';

interface GetOneOptionGroupResponse {
  type: 'option-group';
  data: DetailedOptionGroup[];
}

export const getOptionGroup = async (optionGroupId: string, priceSchemeId: string): Promise<DetailedOptionGroup> => {
  const response = await fetch(`${API_URL}/option-groups/${optionGroupId}`, {
    headers: {
      'Content-Type': 'application/json',
      [PRICE_SCHEME_HEADER]: priceSchemeId,
    },
  });

  if (!response.ok) {
    throw new Error('We have been unable to complete your request. Please try again');
  }

  const { data }: GetOneOptionGroupResponse = await response.json();
  const optionGroup = data.at(0);
  if (!optionGroup) {
    throw new Error('We have been unable to complete your request. Please try again');
  }

  return optionGroup;
};
